import { useEffect } from "react";
import Lenis from "lenis";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";

// Scroll to an element by id, honouring the active Lenis instance if present.
export function scrollToId(id, { offset = 0 } = {}) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}


// Wraps the app in Lenis smooth momentum scrolling.
// Disabled when the user prefers reduced motion.
export default function SmoothScroll({ children }) {
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    if (reduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.4,
    });
    window.__lenis = lenis;

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, [reduced]);

  return children;
}
